(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Homepage-Slider"] && !window.DesignMode) return;
  try {
    
  $('.main-carousel').flickity({
  contain: true,
    pageDots: false,
    freeScroll: true
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-content"]) return;
  try {
    
  $(document).ready(function() {
    // Toggle tabbed layout for mobile
    function toggleTabbedLayout() {
      if ($(window).width() <= 767) {
        $('.tab-item-title').on('click', function() {
          $(this).parent().toggleClass('is-active');
          $(this).next('.tab-item-content').slideToggle();
          $(this).find('i').toggleClass('fa-chevron-down fa-chevron-up');
        });
      } else {
        $('.tab-item-title').off('click');
        $('.tab-item').removeClass('is-active');
        $('.tab-item-content').removeAttr('style');
        $('.tab-item-title i').removeClass('fa-chevron-up').addClass('fa-chevron-down');
      }
    }

    // Call toggleTabbedLayout on page load and window resize
    toggleTabbedLayout();
    $(window).on('resize', toggleTabbedLayout);
  });

  } catch(e) { console.error(e); }
})();
})();
